/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Nikolay Sviridov
 * @version 1.33.0
 * @since 1.33.0
 */

import produce from 'immer';
import { Reducer } from 'redux';

import { TWizardImportSubscribersLimitsActions } from './types/wizardImportSubscribersLimitsActionTypes';
import { IWizardImportSubscribersLimitsValidation, IWizardImportSubscribersLimitsWarningSettings } from './types/wizardImportSubscribersLimitsTypes';
import {
    initWizardImportSubscribersLimitsState, 
    WIZARD_IMPORT_SUBSCRIBERS_LIMITS_ATTACH_FILE, 
    WIZARD_IMPORT_SUBSCRIBERS_LIMITS_ATTACH_FILE_FAILED, 
    WIZARD_IMPORT_SUBSCRIBERS_LIMITS_ATTACH_FILE_SUCCESSFUL,
    WIZARD_IMPORT_SUBSCRIBERS_LIMITS_SET_PARAMS,
    WIZARD_IMPORT_SUBSCRIBERS_LIMITS_SET_STEP_VALID,
} from './wizardImportSubscribersLimitsConstant';

export interface IWizardImportSubscribersLimitsReducer {
    errorCode: string;
    errorRowsAmount: number;
    importFileFormat: string[];
    fileIsLoading: boolean;
    fileName: string;
    fileRowsAmount: number;
    fileTemplateUrl: string;
    maxImportSubscriberAmount: number;
    maxFileName: number;
    maxFileSize: number;
    removedRowsAmount: number;
    resultFileId: string;
    validation: IWizardImportSubscribersLimitsValidation;
    warningSettings: IWizardImportSubscribersLimitsWarningSettings;
}

const wizardImportSubscribersLimitsReducer: Reducer<
    IWizardImportSubscribersLimitsReducer, 
    TWizardImportSubscribersLimitsActions
    > =
    (state = initWizardImportSubscribersLimitsState, action: TWizardImportSubscribersLimitsActions) =>
        produce(state, draft => {
            switch (action.type) {
                case WIZARD_IMPORT_SUBSCRIBERS_LIMITS_SET_PARAMS:
                    Object.assign(draft, { ...draft, ...action.payload });
                    break;
                case WIZARD_IMPORT_SUBSCRIBERS_LIMITS_SET_STEP_VALID:
                    draft.validation.isValid = action.payload.isStepValid;
                    draft.validation.error = action.payload.validateError;
                    break;
                case WIZARD_IMPORT_SUBSCRIBERS_LIMITS_ATTACH_FILE:
                    draft.fileIsLoading = true;
                    draft.fileName = '';
                    draft.errorCode = '';
                    break;
                case WIZARD_IMPORT_SUBSCRIBERS_LIMITS_ATTACH_FILE_FAILED:
                    draft.fileIsLoading = false;
                    break;
                case WIZARD_IMPORT_SUBSCRIBERS_LIMITS_ATTACH_FILE_SUCCESSFUL:
                    draft.fileIsLoading = false;
                    draft.fileName = action.payload.fileName;
                    draft.fileRowsAmount = action.payload.fileRowsAmount;
                    draft.resultFileId = action.payload.resultFileId;
                    draft.errorCode = '';
                    break;
            }
        });

export default wizardImportSubscribersLimitsReducer;
